<template>
  <v-container>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header>一括登録</template>
      <template v-slot:annotation>
        <p>
          Hitonobiを使用しているお客様の役職情報、スタッフ情報を一括登録します。以下の操作を実施してください。
        </p>
        <p>1.一括登録するお客様を選択します。</p>
        <p>
          2.登録する情報を入力した規定のCSVファイルをアップロードし、登録処理を行います。
        </p>
      </template>
    </PageHeader>

    <div class="text-center px-3">
      <v-row>
        <v-col cols="12" sm="12" md="6">
          <v-select
            :items="organizationItems"
            v-model="organizationSelect"
            item-text="label"
            item-value="value"
            label="お客様を選択"
            persistent-hint
            return-object
            single-line
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="6">
          <div
            class="drop_area"
            @dragenter="dragEnter"
            @dragleave="dragLeave"
            @dragover.prevent
            @drop.prevent="dropFile"
            :class="{ enter: isEnter }"
          >
            ファイルアップロード
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="6">
          <ul class="flex">
            <li
              v-for="file in files"
              :key="file.name"
              class="flex-col"
              @click="deleteFile(file.name)"
            >
              <span class="delete-mark">×</span>
              <v-icon color="black"
                >mdi-badge-account-horizontal-outline</v-icon
              >
              <span>{{ file.name }}</span>
            </li>
          </ul>
        </v-col>
      </v-row>
      <v-row v-if="loading"
        ><v-col><Loader :loading="loading" /></v-col
      ></v-row>
      <v-row>
        <v-col cols="12" sm="12" md="6">
          <Button @click="erntry_confirm" color="primary">登録</Button>
        </v-col>
      </v-row>
    </div>

    <div>
      <ConfirmDialog
        ref="confirm"
        title="一括登録"
        :message="confirmMessage"
        buttonMessage="OK"
        @confirm="onUserCsvUpload"
      >
      </ConfirmDialog>
      <DialogMessageAsync ref="asyncdialog" @confirm="asyncDialogBack">
      </DialogMessageAsync>

      <DialogMessage ref="dialog" />
    </div>
  </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import config from '../../const.js';
import message from '../../message.js';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import DialogMessageAsync from '@/components/Common/DialogMessageAsync.vue';
import {
  getSessionStorageItem,
  splitLineCsv,
  splitDataCsv,
} from '../../common.js';
export default {
  components: {
    ConfirmDialog,
    DialogMessageAsync,
  },
  data() {
    return {
      // Breadcrumbs
      crumbs: [
        {
          name: '一括登録',
          route: 'BulkEntry',
        },
      ],

      // 変数宣言
      showContent: false,
      loading: false,
      confirmMessage: null,
      searchKey: '',
      confirm: false,

      // パラメータ取得
      organizationName: '',
      loginName: '',
      dispPosition: '',
      sessionId: '',
      // 組織情報
      organizationItems: [],
      organizationSelect: { label: '', value: '' },
      // 一括登録用Excelファイルパス
      uploadExcelPath: '',
      //
      file: '',
      files: [],
      isEnter: false,
      userArray: [],
      gradeArray: [],
      departmentArray: [],
      positionArray: [],

      isPosition: false,

      isUserGetCsv: false,
      isGradeGetCsv: false,
      isDepartmentGetCsv: false,
      isPositionGetCsv: false,
      isGetCsvComplete: false,

      isUserBulkPost: false,
      userCsvFileName: '',
      gradeCsvFileName: '',
      departmentCsvFileName: '',
      positionCsvFileName: '',
    };
  },
  created() {
    // 組織情報取得
    this.get_organizations();
  },
  watch: {
    isUserGetCsv: function () {
      // isUserGetCsvがTrueの場合、次に等級情報のCSVデータ取得
      if (this.isUserGetCsv) {
        this.loading = true;
        this.onGradeCsvUpload();
      }
    },
    isGradeGetCsv: function () {
      // isGradeGetCsvがTrueの場合、次に部署情報のCSVデータ取得
      if (this.isGradeGetCsv) {
        this.loading = true;
        this.onDepartmentCsvUpload();
      }
    },
    isDepartmentGetCsv: function () {
      // isDepartmentGetCsvがTrueの時、次に部署情報のCSVデータ取得
      if (this.isDepartmentGetCsv) {
        this.loading = true;
        this.onPositionCsvUpload();
      }
    },
    isPositionGetCsv: function () {
      // isPositionGetCsvがTrueの時、次にユーザー作成状態チェック
      if (this.isPositionGetCsv) {
        this.loading = true;
        this.checkUserMakeStatus();
      }
    },
    isGetCsvComplete: function () {
      // isGetCsvCompleteがTrueの時、ユーザ情報一括登録POST
      if (this.isGetCsvComplete) {
        this.loading = true;
        this.bulkOrganizationEntryPost();
      }
    },
  },
  methods: {
    asyncDialogBack() {
      // オーナー画面遷移処理
      this.$router.push({ name: 'OwnerTop' });
    },
    get_organizations() {
      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      // ローディング画像表示
      this.loading = true;
      let vm = this;

      axios
        .get(
          config.CONNECT_OWNER_URL +
            '/Owner/organizations/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            config.EMPTY_STRING +
            '/' +
            config.EMPTY_STRING
        )
        .then((response) => {
          // 組織データ取得
          if (response.data.length > 0) {
            for (var i = 0; i < response.data.length; i++) {
              const value = {
                label: response.data[i].ORGANIZATION_NAME,
                value: response.data[i].ORGANIZATION_KEY,
              };
              vm.organizationItems.push(value);
            }
          } else {
            // 組織データが取得できない場合
            this.searchKey = '';
            this.$refs.dialog.open(
              'info',
              message.MSG_INFO_SEARCH_ORGANIZATION_NOT_FOUND
            );
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
    dragEnter() {
      this.isEnter = true;
    },
    dragLeave() {
      this.isEnter = false;
    },
    dragOver() {
      console.log('DragOver');
    },
    dropFile() {
      var uploadFiles = event.dataTransfer.files;
      // お客様名選択チェック
      if (!this.organizationSelect.value) {
        this.$refs.dialog.open(
          'info',
          '一括登録するお客様を選択後、ファイルをアップロードしてください。'
        );
        return;
      }
      this.userCsvFileName =
        config.USER_CSV_FILE_NM_BULK_ENTRY +
        this.organizationSelect.value +
        config.CSV_EXTENSION;
      this.gradeCsvFileName =
        config.GRADE_CSV_FILE_NM_BULK_ENTRY +
        this.organizationSelect.value +
        config.CSV_EXTENSION;
      this.departmentCsvFileName =
        config.DEPARTMENT_CSV_FILE_NM_BULK_ENTRY +
        this.organizationSelect.value +
        config.CSV_EXTENSION;
      this.positionCsvFileName =
        config.POSITION_CSV_FILE_NM_BULK_ENTRY +
        this.organizationSelect.value +
        config.CSV_EXTENSION;

      // アップロードファイル名チェック
      for (var num = 0; num < uploadFiles.length; num++) {
        if (
          uploadFiles[num].name != this.userCsvFileName &&
          uploadFiles[num].name != this.gradeCsvFileName &&
          uploadFiles[num].name != this.departmentCsvFileName &&
          uploadFiles[num].name != this.positionCsvFileName
        ) {
          // アップロード可能ファイル以外の場合、処理終了
          let infoStr = message.MSG_INFO_POSSIBLE_UPLOAD_FILE;
          let infoStrReplace = infoStr.replace(/a/g, uploadFiles[num].name);
          this.$refs.dialog.open('info', infoStrReplace);
          this.isEnter = false;
          return;
        }
      }
      // 既存のアップロードファイルチェック
      for (var i = 0; i < this.files.length; i++) {
        for (var j = 0; j < uploadFiles.length; j++) {
          if (this.files[i].name == uploadFiles[j].name) {
            // 既にアップロードされていた場合、処理終了
            let infoStr = message.MSG_INFO_ALREADY_UPLOAD_FILE;
            let infoStrReplace = infoStr.replace(/a/g, uploadFiles[j].name);
            this.$refs.dialog.open('info', infoStrReplace);
            this.isEnter = false;
            return;
          }
        }
      }
      this.files.push(...event.dataTransfer.files);
      this.isEnter = false;
    },
    deleteFile(index) {
      this.files.splice(index, 1);
    },
    erntry_confirm() {
      // お客様名選択チェック
      if (!this.organizationSelect.value) {
        this.$refs.dialog.open(
          'info',
          '一括登録するお客様を選択してください。'
        );
        return;
      }
      // ファイル存在チェック
      var isExistsUser = false;
      var isExistsGrade = false;
      var isExistsDepartment = false;
      var isExistsPosition = false;

      for (var fileCnt = 0; fileCnt < this.files.length; fileCnt++) {
        if (this.files[fileCnt].name == this.userCsvFileName) {
          isExistsUser = true;
        } else if (this.files[fileCnt].name == this.gradeCsvFileName) {
          isExistsGrade = true;
        } else if (this.files[fileCnt].name == this.departmentCsvFileName) {
          isExistsDepartment = true;
        } else if (this.files[fileCnt].name == this.positionCsvFileName) {
          isExistsPosition = true;
        }
      }
      if (
        !isExistsUser &&
        !isExistsGrade &&
        !isExistsDepartment &&
        !isExistsPosition
      ) {
        // アップロード可能ファイルが存在しない場合、処理終了
        this.$refs.dialog.open(
          'info',
          '一括登録するファイルが存在しません。\n' +
            ' 一括登録用ファイルをアップロードしてください。'
        );
        return;
      }
      if (!isExistsUser) {
        // ユーザアップロードファイルが存在しない場合、処理終了
        this.$refs.dialog.open(
          'info',
          '一括登録するユーザ情報のファイルが存在しません。\n' +
            ' 一括登録用_ユーザ情報ファイルをアップロードしてください。'
        );
        return;
      }
      if (!isExistsGrade) {
        // 等級アップロードファイルが存在しない場合、処理終了
        this.$refs.dialog.open(
          'info',
          '一括登録する等級情報のファイルが存在しません。\n' +
            ' 一括登録用_等級情報ファイルをアップロードしてください。'
        );
        return;
      }
      if (!isExistsDepartment) {
        // 部署アップロードファイルが存在しない場合、処理終了
        this.$refs.dialog.open(
          'info',
          '一括登録する部署情報のファイルが存在しません。\n' +
            ' 一括登録用_部署情報ファイルをアップロードしてください。'
        );
        return;
      }
      if (!isExistsPosition) {
        // 役職アップロードファイルが存在しない場合、処理終了
        this.$refs.dialog.open(
          'info',
          '一括登録する役職情報のファイルが存在しません。\n' +
            ' 一括登録用_役職情報ファイルをアップロードしてください。'
        );
        return;
      }

      var userFileNameStr = this.userCsvFileName;
      var result = userFileNameStr.indexOf(this.organizationSelect.value);
      if (result == -1) {
        // アップロードしているファイルと選択したお客様が異なる場合、処理終了
        this.$refs.dialog.open(
          'info',
          '一括登録するファイルと選択しているお客様の情報が異なります。\n' +
            ' 再度、ご確認をお願いします。'
        );
        return;
      }

      // CSV読込フラグ初期化
      this.isUserGetCsv = false;
      this.isGradeGetCsv = false;
      this.isDepartmentGetCsv = false;
      this.isPositionGetCsv = false;
      this.isGetCsvComplete = false;

      // 確認ダイアログ表示
      this.confirmMessage =
        this.organizationSelect.label +
        '様の情報を一括登録しますか？\n' +
        ' ※100名以上のスタッフ様の情報を登録するとシステムが遅くなる可能性があります。';
      this.$refs.confirm.open();
    },

    // ユーザ情報一括登録
    onUserCsvUpload() {
      for (var num = 0; num < this.files.length; num++) {
        if (this.files[num].name == this.userCsvFileName) {
          this.makeUserEntryJson(this.files[num]);
          break;
        }
      }
    },
    // 等級情報一括登録
    onGradeCsvUpload() {
      for (var num = 0; num < this.files.length; num++) {
        if (this.files[num].name == this.gradeCsvFileName) {
          this.makeGradeEntryJson(this.files[num]);
          break;
        }
      }
    },
    // 部署情報一括登録
    onDepartmentCsvUpload() {
      for (var num = 0; num < this.files.length; num++) {
        if (this.files[num].name == this.departmentCsvFileName) {
          this.makeDepartmentEntryJson(this.files[num]);
          break;
        }
      }
    },
    // 役職情報一括登録
    onPositionCsvUpload() {
      for (var num = 0; num < this.files.length; num++) {
        if (this.files[num].name == this.positionCsvFileName) {
          this.makePositionEntryJson(this.files[num]);
          break;
        }
      }
    },
    // ユーザー作成状態チェック
    checkUserMakeStatus() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      //----- ユーザ作成状態チェック
      axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/Organization/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            this.organizationSelect.value
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;
          let userMakeStatus = response.data[0].USER_MAKE_STATUS;
          if (userMakeStatus == config.EXEC_RUN) {
            // 1:実行中の場合は処理終了
            this.$refs.dialog.open(
              'info',
              '組織情報一括設定処理が実行中です。\n' +
                ' しばらく時間が経過した後に実行をお願いします。'
            );
            return;
          } else {
            // 一括登録開始フラグをONに設定
            this.isGetCsvComplete = true;
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },

    // ユーザ情報ファイル取得
    makeUserEntryJson(file) {
      let that = this;
      var reader = new FileReader();
      reader.readAsText(file);
      reader.onload = function () {
        // ユーザCSVデータ取得
        that.userArray = [];
        var userCsvData = reader.result.replace(/\r/g, '');
        var userCsvCol = splitLineCsv(userCsvData);
        var userColsNum = 0;
        var userCsvRowData = [];

        for (var i = 0; i < userCsvCol.length; i++) {
          var tmpCsvCol = userCsvCol[i].replace(/^\n/, '');
          if (tmpCsvCol) {
            userColsNum++;
          }
        }

        for (var j = 0; j < userColsNum; j++) {
          userCsvRowData = splitDataCsv(userCsvCol[j]);

          // 連想配列作成処理
          if (userCsvRowData[0]) {
            var entryUserId =
              userCsvRowData[1] + moment().format('YYYYMMDDHHmmss') + (j + 1);
            let userRow = {
              USER_ID: entryUserId,
              LOGIN_ID: userCsvRowData[0],
              PASSWORD: '',
              ORGANIZATION_KEY: userCsvRowData[1],
              DEPARTMENT_KEY: userCsvRowData[2],
              DEPARTMENT_NAME: userCsvRowData[3],
              USER_FAMILY_NAME: userCsvRowData[4],
              USER_FAMILY_NAME_FURIGANA: userCsvRowData[5],
              USER_FIRST_NAME: userCsvRowData[6],
              USER_FIRST_NAME_FURIGANA: userCsvRowData[7],
              USER_NAME: userCsvRowData[8],
              USER_NAME_FURIGANA: userCsvRowData[9],
              USER_RANK: userCsvRowData[10],
              POSITION_ID: userCsvRowData[11],
              POSITION_NAME: userCsvRowData[12],
              SHOW_TITLE:
                "<span class='text--primary'>" + userCsvRowData[8] + '</span> ',
              USER_AVATER: entryUserId + '.jpg',
              START_WORKING_AT: userCsvRowData[13],
              END_WORKING_AT: config.END_WORKING_AT_INIT,
              EXPIRATION: '0', // 使用開始
              CREATED_AT: moment().format('YYYYMMDDHHmmss'),
              UPDATED_AT: moment().format('YYYYMMDDHHmmss'),
              USER_AVATER_IMAGE: '',
              GRADE_ID: userCsvRowData[14], // 等級ID
              GRADE_NAME: userCsvRowData[15], // 等級名
              GRADE_JOIN_DATE: userCsvRowData[13],
              GRADE_LEAVE_DATE: config.END_WORKING_AT_INIT,
            };
            that.userArray.push(userRow);
          }
        }
        that.isUserGetCsv = true;
      };
    },

    // 等級情報ファイル取得
    makeGradeEntryJson(file) {
      let that = this;
      var reader = new FileReader();
      reader.readAsText(file);
      reader.onload = function () {
        // 等級CSVデータ取得
        that.gradeArray = [];
        var gradeCsvData = reader.result.replace(/\r/g, '');
        var gradeCsvCol = splitLineCsv(gradeCsvData);
        var gradeColsNum = 0;
        var gradeCsvRowData = [];

        for (var i = 0; i < gradeCsvCol.length; i++) {
          var tmpCsvCol = gradeCsvCol[i].replace(/^\n/, '');
          if (tmpCsvCol) {
            gradeColsNum++;
          }
        }

        for (var j = 0; j < gradeColsNum; j++) {
          gradeCsvRowData = splitDataCsv(gradeCsvCol[j]);

          // ここから連想配列作成処理
          if (gradeCsvRowData[0]) {
            let gradeRow = {
              GRADE_ID: gradeCsvRowData[0],
              ORGANIZATION_KEY: gradeCsvRowData[1],
              GRADE_NAME: gradeCsvRowData[2],
              USER_RANK: gradeCsvRowData[3],
              SHOW_ORDER: gradeCsvRowData[4],
              EXPIRATION: config.USE_IN,
              CREATED_AT: moment().format('YYYYMMDDHHmmss'),
              UPDATED_AT: moment().format('YYYYMMDDHHmmss'),
            };
            that.gradeArray.push(gradeRow);
          }
        }
        that.isGradeGetCsv = true;
      };
    },

    // 部署情報ファイル取得
    makeDepartmentEntryJson(file) {
      let that = this;
      var reader = new FileReader();
      reader.readAsText(file);
      reader.onload = function () {
        // 部署CSVデータ取得
        that.departmentArray = [];
        var departmentCsvData = reader.result.replace(/\r/g, '');
        var departmentCsvCol = splitLineCsv(departmentCsvData);
        var departmentColsNum = 0;
        var departmentCsvRowData = [];

        for (var i = 0; i < departmentCsvCol.length; i++) {
          var tmpCsvCol = departmentCsvCol[i].replace(/^\n/, '');
          if (tmpCsvCol) {
            departmentColsNum++;
          }
        }

        for (var j = 0; j < departmentColsNum; j++) {
          departmentCsvRowData = splitDataCsv(departmentCsvCol[j]);

          // ここから連想配列作成処理
          if (departmentCsvRowData[0]) {
            let departmentRow = {
              DEPARTMENT_KEY: departmentCsvRowData[0],
              ORGANIZATION_KEY: departmentCsvRowData[1],
              DEPARTMENT_NAME: departmentCsvRowData[2],
              DEPARTMENT_NAME_FURIGANA: departmentCsvRowData[3],
              SHOW_ORDER: departmentCsvRowData[4],
              EXPIRATION: config.USE_IN,
              CREATED_AT: moment().format('YYYYMMDDHHmmss'),
              UPDATED_AT: moment().format('YYYYMMDDHHmmss'),
            };
            that.departmentArray.push(departmentRow);
          }
        }
        that.isDepartmentGetCsv = true;
      };
    },

    // 役職情報ファイル取得
    makePositionEntryJson(file) {
      let that = this;
      var reader = new FileReader();
      reader.readAsText(file);
      reader.onload = function () {
        // 役職CSVデータ取得
        that.positionArray = [];
        var positionCsvData = reader.result.replace(/\r/g, '');
        var positionCsvCol = splitLineCsv(positionCsvData);
        var positionColsNum = 0;
        var positionCsvRowData = [];

        for (var i = 0; i < positionCsvCol.length; i++) {
          var tmpCsvCol = positionCsvCol[i].replace(/^\n/, '');
          if (tmpCsvCol) {
            positionColsNum++;
          }
        }

        for (var j = 0; j < positionColsNum; j++) {
          positionCsvRowData = splitDataCsv(positionCsvCol[j]);

          // ここから連想配列作成処理
          if (positionCsvRowData[0]) {
            let positionRow = {
              POSITION_ID: positionCsvRowData[0],
              ORGANIZATION_KEY: positionCsvRowData[1],
              POSITION_NAME: positionCsvRowData[2],
              POSITION_NAME_FURIGANA: positionCsvRowData[3],
              SHOW_ORDER: positionCsvRowData[4],
              EXPIRATION: config.USE_IN,
              CREATED_AT: moment().format('YYYYMMDDHHmmss'),
              UPDATED_AT: moment().format('YYYYMMDDHHmmss'),
            };
            that.positionArray.push(positionRow);
          }
        }
        that.isPositionGetCsv = true;
      };
    },

    bulkOrganizationEntryPost() {
      // セッションチェック
      let userInfo = getSessionStorageItem();
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      // ローディング画像開始
      this.loading = true;

      // 組織情報一括登録 (リクエスト返却まで待つ)
      axios
        .post(config.CONNECT_OWNER_URL + '/Owner/BulkEntry/organizations', {
          SESSION_ID: userInfo.SESSION_ID,
          SESSION_USER_ID: userInfo.USER_ID,
          ORGANIZATION_KEY: this.organizationSelect.value,
          USER_JSON: JSON.stringify(this.userArray),
          GRADE_JSON: JSON.stringify(this.gradeArray),
          DEPARTMENT_JSON: JSON.stringify(this.departmentArray),
          POSITION_JSON: JSON.stringify(this.positionArray),
        })
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr =
              this.organizationSelect.label +
              'の一括登録処理を開始しました。\n' +
              ' 登録処理には最大15分程度かかります。';
            this.$refs.asyncdialog.open('info', msgStr);
            //this.$refs.dialog.open('info', msgStr);
          }
          // 一括登録フラグを初期化
          this.isUserGetCsv = false;
          this.isGradeGetCsv = false;
          this.isDepartmentGetCsv = false;
          this.isPositionGetCsv = false;
          this.isGetCsvComplete = false;
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
          // ユーザ情報一括登録フラグを初期化
          this.isUserGetCsv = false;
          this.isUserBulkPost = false;
        });
    },
  },
};
</script>
<style>
.drop_area {
  color: gray;
  font-weight: bold;
  font-size: 1.2em;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  border: 5px solid gray;
  border-radius: 15px;
}
.enter {
  border: 10px dotted powderblue;
}
.flex {
  display: flex;
  align-items: center;
}
.flex-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0.5em;
  font-size: 20px;
}
.delete-mark {
  position: absolute;
  top: -14px;
  right: -10px;
  font-size: 20px;
}
ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
</style>
